import '../styles/main.scss'
import '@/lib/select.js'
import app from '@/app.js'
import ctx from '@/app.js'
import { fetchCart } from '@/lib/cart.js'
import { getThemes } from '@/lib/indexFunctions.js'
import { formatMoney } from '@/lib/currency.js'

import cssVars from 'css-vars-ponyfill'
import 'lazysizes/plugins/rias/ls.rias'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks'
import lazySizes from 'lazysizes'
import objectFitImages from 'object-fit-images'

objectFitImages()
cssVars()

const widths = [
    30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360, 390, 450, 540, 630, 720, 810, 900, 990, 1080, 1260, 1440,
    1620, 1800, 1980, 2340, 2700, 3060,
]

lazySizes.cfg.loadHidden = false
lazySizes.cfg.rias.widths = widths

document.addEventListener(
    'lazyriasmodifyoptions',
    ((e) => {
        return (event) => {
            const maxWidth = Number(event.target.getAttribute('data-max-width'))
            if (maxWidth) event.detail.widths = widths.filter((w) => w <= maxWidth)
        }
    })()
)

localStorage.removeItem('slater-scroll')

//*/ ForEach IE fallback /*//
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this)
        }
    }
}

//*/ Cursor changes when hovering over images /*//
const body = document.querySelector('body')
const hoverIcon = document.querySelector('[data-hover-icon]')
const hoverImages = document.querySelectorAll('[data-hover-image]')
let x = 0
let y = 0

const moveIcon = () => {
    if (window.innerWidth > 1024) {
        hoverIcon.style.transform = `translate(${x}px, ${y}px)`
        requestAnimationFrame(moveIcon)
    }
}
requestAnimationFrame(moveIcon)
window.addEventListener('resize', moveIcon)

const removeDefaultCursor = () => {
    body.classList.add('no-cursor')
}

const addDefaultCursor = () => {
    body.classList.remove('no-cursor')
}

document.addEventListener('mousemove', (e) => {
    x = e.clientX
    y = e.clientY
})

hoverImages.forEach((hoverImage) => {
    hoverImage.addEventListener('mouseenter', removeDefaultCursor)
    hoverImage.addEventListener('mouseleave', addDefaultCursor)
})

function ctxOnPoly() {
    if (typeof window.CustomEvent === 'function') return false
    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: null }
        var evt = document.createEvent('CustomEvent')
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
        return evt
    }
    window.CustomEvent = CustomEvent
}
ctxOnPoly()

app.on('cart:updated', ({ cart }) => {

})

//*/ Hydrate cart and theme /*//
Promise.all([fetchCart(), getThemes()]).then(([cart, theme]) => {
    /* Hent data fra kurven, og skyd derefter dataen ind i app-variablen */
    app.hydrate({ cart, theme })

    /* Mount af alle components */
    app.mount()
})
